import type { ExpressShipping } from "./shipping-types/express-shipping";
import type { LoopShipping } from "./shipping-types/loop-shipping";
type Shipping = LoopShipping | ExpressShipping;

// eslint-disable-next-line @typescript-eslint/no-explicit-any
const isExpressShipping = (shipping: any): shipping is ExpressShipping => {
    return "shippingType" in shipping && shipping.shippingType === "EXPRESS";
};

export type { Shipping };
export { isExpressShipping };
